/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum EventType {
    DOCTOR_APPOINTMENT = 'doctor_appointment',
    CUSTOM_EVENT = 'custom_event',
}
